import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import useWorkspace from "../workspaces/useWorkspace";
import PageAPI from "../../api/PageAPI";
import { newToastEvent } from "../../../utils/ToastUtil";
import { useNavigate } from "react-router-dom";

const useDuplicatePage = () => {
  const { workspace } = useWorkspace();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { tenantID }: any = useParams();

  const duplicatePage = useMutation({
    mutationFn: (pageID: string) =>
      PageAPI.duplicatePage(workspace.id, pageID).then((data) => {
        const { page, workspace, owner } = data.data.data;
        return { page, workspace, owner, pageID };
      }),

    onSuccess: ({ page, workspace, owner, pageID }) => {
      queryClient.setQueryData(["user", tenantID], (prev) => ({
        ...(prev || {}),
        user: owner,
      }));
      queryClient.invalidateQueries({
        queryKey: ["workspaces", tenantID],
      });
      queryClient.invalidateQueries({
        queryKey: ["pages", workspace.id],
      });
      queryClient.invalidateQueries({
        queryKey: ["workspace", workspace.id],
      });

      newToastEvent("success", "Successfully duplicated page.");

      navigate(
        `/clouds/${tenantID}/workspaces/${workspace.id}/pages/${page.id}/views/None`
      );
    },
  });

  return {
    duplicatePage: duplicatePage.mutate,
    pageDuplicating: duplicatePage.isPending,
  };
};

export default useDuplicatePage;
